/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_OpenInputs */

const en_planner_open = /** @type {(inputs: Planner_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggest a week`)
};

const de_planner_open = /** @type {(inputs: Planner_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woche vorschlagen`)
};

/**
* | output |
* | --- |
* | "Suggest a week" |
*
* @param {Planner_OpenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_open = /** @type {((inputs?: Planner_OpenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_OpenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_open(inputs)
	return en_planner_open(inputs)
});